import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-179" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-180" data-mp="yto8on8960iw">
        <h2 className="text-center text-2xl font-bold leading-tight tracking-tight text-stone-900 sm:text-3xl" data-id="element-181" data-mp="kx13xya2662f">
          <span aria-hidden="true" data-id="element-182" data-mp="pu16hz7p8qos">📦 </span>What&apos;s Inside the Math Ready
          Pack?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-183" data-mp="b4vaek45rgl4">
          {packItems.map(item => <li key={item.title} className="rounded-xl border border-stone-200 bg-stone-50 px-6 py-8 text-center" data-id="element-184" data-mp="fyfz1ljv2y7n">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-185" data-mp="741mvrumo3sr">
                {item.emoji}
              </span>
              <h3 className="mt-4 text-base font-semibold text-stone-900" data-id="element-186" data-mp="3oe9fk0e709op">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-stone-600" data-id="element-187" data-mp="3te5l442jg96d">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}